/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: =, Brian Bal, Ivan Ryabov, Leonid Khramov
 */
import React, { Component } from 'react'
import Color from 'color'
import moment from 'moment'
import { valueFor } from '../../util/helpers'
import { apiFolder } from '../../util/apiFolder'

import * as links from '../../util/links'

import './TeamGameItem.css'

class TeamGameItem extends Component {

    constructor(props) {
        super(props)

        this.openGame = this.openGame.bind(this)
        this.openEditor = this.openEditor.bind(this)
    }

    get homeStyles() {
        let homeColor = valueFor('game.home_team.jersey_color', '#000', this.props)
        let hc
        try {
            hc = Color(homeColor)
        }
        catch (e) {
            hc = Color('#000')
            homeColor = '#000'
        }
        let homeStyles = {
            backgroundColor: homeColor,
            color: hc.luminosity() > 0.59 ? '#000' : '#fff'
        }
        return homeStyles
    }

    get awayStyles() {
        let awayColor = valueFor('game.away_team.jersey_color', '#fff', this.props)
        let ac
        try {
            ac = Color(awayColor)
        } catch(e) {
            ac = Color('#fff')
            awayColor = '#fff'
        }
        let awayStyles = {
            backgroundColor: awayColor,
            color: ac.luminosity() > 0.59 ? '#000' : '#fff'
        }
        return awayStyles
    }

    gameDate(game) {
        let date = game.approx_start_time ? game.date.substring(0, 11) + ' ' + game.approx_start_time : game.date
        return moment.utc(date, "YYYY-MM-DD hh:mm:ss").local().format('MM/DD/YY @ hh:mm')
    }

    makeRgbaFromRGB(rgb, alpha = 0.5) {
        let r = parseInt(rgb.slice(1,3), 16)
        let g = parseInt(rgb.slice(3,5), 16)
        let b = parseInt(rgb.slice(5), 16)
        return `rgba(${r},${g},${b},${alpha})`
    }

    openGame(e) {
        console.log(e)
        if (e && e.target && e.target.className === "no-tracers") {
            return
        }
        e.preventDefault()

        if (this.props.game.list_status === 'ready') {
            const tm = this.props.game.home_team.name
            const gwid = this.props.game.game_id
            // distinguish between old sensorless game that have only mp4 videos,
            // new sensorles with moments and the CV games
            let sensorlessCuttoffDate = moment("2020-10-01", "YYYY-MM-DD").utc()
            let gameDate = moment.utc(this.props.game?.date)
            const gameUrl = this.props.game.video_render_type === 'sensorless' && (gameDate < sensorlessCuttoffDate) &&
                (!this.props.game.subtasks_statuses.videos
                    || this.props.game.subtasks_statuses.videos.status !== 'processed')
                ? links.gameDownloadOnlyUrl(tm, gwid, 'first')
                : (this.props.game.video_render_type === 'sensorless'
                    ? links.gameUrl(tm, 'goals', gwid)
                    : links.gameUrl(tm, 'goals', gwid) + '/choose')
            this.props.history.push(gameUrl)
            return
        }
        else if (this.props.game.list_status !== 'error') {
            this.openEditor()
        }
        else if (this.props.game.list_status !== 'error') {
            window.location.href = 'https://q.traceup.com/t/8025n3/flagged-for-support'
        }
    }

    openEditor(e) {
        if (e) { e.preventDefault() }
        const tm = this.props.game.home_team.name
        const gid = this.props.game.game_id
        const editUrl = `/${tm}/game-editor/${gid}/edit`

        this.props.history.push(editUrl)
    }

    render() {
        // console.log("TeamGameItem.render", this.props);
        console.log("GAME INFO", this.props.game.sport_type, this.props.game.video_sport_type)
        // Game Info
        const tm = this.props.game.home_team.name
        const gid = this.props.game.game_id
        const gwid = this.props.game.game_id_hash
        const thumbUrl = `${apiFolder(this.props.game)}/teams/${tm}/games/${gwid}/poster.jpg`
        const editUrl = `/${tm}/game-editor/${gid}/edit`
        let date = this.gameDate(this.props.game)
        let noTracers = null

        // no tracers
        if (this.props.game.video_render_type === 'sensorless') {
            noTracers = (<><a className="no-tracers" href="https://traceup.com/soccer/help/sensorless-game-results" rel="noopener noreferrer" target="_blank">No Tracers</a> 🙁</>)
        }

        // Home Team Info
        var homeAbr = '--'
        if (this.props.game.home_team.abbr) {
            homeAbr = this.props.game.home_team.abbr.substring(0,5)
        }

        // Away Team Info
        var awayAbr = '--'
        if (this.props.game.away_team.abbr) {
            awayAbr = this.props.game.away_team.abbr.substring(0,5)
        }


        // Conditional Rendering
        var playButton = ''
        var editButton = ''
        if (this.props.game.list_status === 'ready') {
            playButton = (<div className="play"></div>)
            if (this.props.isLoggedIn) {
                editButton = (<a href="#edit" className="edit" onClick={(e) => {e.preventDefault(); this.props.history.push(editUrl)}}>Edit</a>)
            }
        }
        var cn = 'TeamGameItem'
        var gameClick = this.openGame

        var overlay = ''
        if (this.props.game.list_status === 'scheduled') {
            cn += ' with-overlay'
            overlay = (
                <div className="overlay">
                    <h2>
                        Scheduled
                    </h2>
                    <p><a href="#edit" className="edit" onClick={this.openEdit}>Edit</a></p>
                    <p className="gamedate">{date}</p>
                </div>
            )
        }
        else if (this.props.game.list_status === 'editing') {
            cn += ' with-overlay'
            overlay = (
                <div className="overlay">
                    <h2>
                        Game in progress
                    </h2>
                    <p><a href="#edit" className="edit" onClick={this.openEdit}>Edit</a></p>
                    <p className="gamedate">{date}</p>
                </div>
            )
        }
        else if (this.props.game.list_status === 'waiting') {
            cn += ' with-overlay'
            overlay = (
                <div className="overlay">
                    <h2>Waiting Tracers &amp; Video</h2>
                    <p><a href="#edit" className="edit" onClick={this.openEdit}>Edit</a></p>
                    <p className="gamedate">{date}</p>
                </div>
            )
        }
        else if (this.props.game.list_status === 'processing') {
            cn += ' with-overlay'
            gameClick = null
            overlay = (
                <div className="overlay">
                    <h2>Processing</h2>
                    <p className="gamedate">{date}</p>
                </div>
            )
        }
        else if (this.props.game.list_status === 'error') {
            cn += ' with-overlay'
            gameClick = null
            overlay = (
                <div className="overlay">
                    <h2>Flagged for Support</h2>
                    <p><a href="https://q.traceup.com/t/8025n3/flagged-for-support">Learn more</a></p>
                    <p className="gamedate">{date}</p>
                </div>
            )
        }

        return (
            <div className={cn}>
                <div className="background" style={{background: 'rgba(0,0,0,0.0)', backgroundImage:'url('+thumbUrl+')', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center center'}}>
                </div>
                <div onClick={gameClick} className="game-item-link">
                    { overlay }
                    <div className="scoreboard">
                        <div className="scoreboard-gutter">
                            <span className="team home" style={this.homeStyles}>
                                {homeAbr}
                            </span>
                            <span className="score">
                                {this.props.game.home_team.score}
                                &nbsp;:&nbsp;
                                {this.props.game.away_team.score}
                            </span>
                            <span className="team away" style={this.awayStyles}>
                                {awayAbr}
                            </span>
                        </div>
                    </div>
                    { playButton }
                    <div className="gamedate">
                        {date}{noTracers}
                    </div>
                </div>
                <div className="gameedit">
                    {editButton}
                </div>

            </div>
        )
    }

}



export default TeamGameItem
